module.exports = function(ejs) {
var __t, __p = '';
__p += '<div class="ggs-gallery-campaign__button" ng-click=":: $ctrl.openRequestHandler()"><div class="ggs-gallery-campaign__text" ng-bind="' +
((__t = ( ejs.LE?'':'::' )) == null ? '' : __t) +
' $ctrl.ggsProperties.campaign_button_text"></div></div>';
return __p
}